export default "__VITE_ASSET__C2rsm47c__"